import React, { createContext, useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const CheckoutFlowContext = createContext(null);

/**
 * Partage l'instance du composant Checkout Flow ainsi que son état (validité,
 * soumission) entre le formulaire CB (rendu dans l'étape de sélection) et le
 * bouton "Je valide mon paiement" (rendu dans le ButtonContainer), qui vivent
 * dans deux sous-arbres distincts du funnel.
 */
export const CheckoutFlowProvider = ({ children }) => {
    const [isValid, setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const flowComponentRef = useRef(null);

    const handlePay = () => {
        if (!flowComponentRef.current || submitting) return;
        // On désactive le bouton dès le clic, le temps que la requête de paiement
        // parte et soit traitée (la page sera redirigée via onPaymentCompleted/onError).
        setSubmitting(true);
        flowComponentRef.current.submit();
    };

    const resetFlow = () => {
        flowComponentRef.current = null;
        setIsValid(false);
        setSubmitting(false);
    };

    return (
        <CheckoutFlowContext.Provider
            value={{ isValid, setIsValid, submitting, flowComponentRef, handlePay, resetFlow }}>
            {children}
        </CheckoutFlowContext.Provider>
    );
};

CheckoutFlowProvider.propTypes = {
    children: PropTypes.node
};

export const useCheckoutFlow = () => {
    const context = useContext(CheckoutFlowContext);
    if (!context) {
        throw new Error('useCheckoutFlow must be used within a CheckoutFlowProvider');
    }
    return context;
};



// WEBPACK FOOTER //
// ./src/components/funnel/payment-step/checkout-flow/CheckoutFlowContext.js